import React from "react";
import Loader from "../Common/Loader";
import { UserContext } from "../Definitions/UserContext";
import { GetBusinessServices } from "../Utilities/BusinessData";
import { OpenAddOnServicePopupForAddToBook } from "../BusinessControls/RenderBusinessServices";
import { utils } from "../../utils/Utils";
import ReactDOM from "react-dom";
import MultiLocationDropdown from "../../VagaroComponent/MultiLocationDropdown";
import { OpenToComponent } from "../Utilities/OpenToComponent";
import { BusienssControlNames } from "./GenericBusinessControl";


export function ToggleLoader(show:boolean){

    let loader = document.querySelector(".wbloader");
    if(loader){

        let lder = loader as HTMLElement;
        if(show){
            lder.style.display = "block"
        }else{
            lder.style.display = "none"
        }
    

    }
}


export function OpenClassFrame({ classId, siteData,locationId, allowMultiLoc}: {siteData:UserContext, classId: string, locationId:string, allowMultiLoc: boolean}) {

    let locationURL = "";

    const Open = (VgUrl:string)=>{
        ToggleLoader(true);
  
        window.wbc.openVagaroPage("divVagaroIframe", `${utils.SiteName()}${VgUrl}/classes?Type=Builder&Event=WBBusinessClasses&ClassID=${classId}&AllowLocation=${allowMultiLoc}`);

    }
    if(allowMultiLoc){
      
          ReactDOM.render(
            <MultiLocationDropdown
            keepContentHidden={false}
            Sitedata={siteData.MultilocationData}
            OnClickEvent={(VgUrl: any) => { Open(VgUrl) }}
            Mode={"wbClasses"}
            userContext={siteData}
        />,
              document.getElementById("OpenDialogMultiLocation")
            )

            return;
          
    }

    if(!locationId)
        locationId = siteData.bidHash;

        for(let i = 0;i<siteData.MultilocationData.length;i++){
            if (siteData.MultilocationData[i].encBusinessID == locationId || siteData.MultilocationData[i].encBIDHash == locationId){
                locationURL = siteData.MultilocationData[i].vagaroURL;
                break;
            }
           }

   Open(locationURL);


}


export function BindServiceLinks(userContext:UserContext){

    let links = document.querySelectorAll('.service-link');

    links.forEach((link) => {
        
        let location = link.getAttribute('datalocation')??userContext.businessId;
        let allowMulti = (link.getAttribute('dataallowmulti')??"false") == "true";

        let serviceId = link.getAttribute("href")??"";
        link.setAttribute("href","#");//dont open via middle click
        
        let context = {...userContext};
        if(location){
            context.businessId = location;
        }

        link.addEventListener('click', (e) => {
            e.preventDefault();

            if((window as any).isEditor){
                return;
            }


            ToggleLoader(true);
            GetBusinessServices(context,(data:any)=>{

                let mainData = data[0];
                if(!mainData){
                    window.alert("No data found");
                    ToggleLoader(false);
                    return;
                }

                let serviceData = null;
                let cats = mainData.serviceCategoryList;

                if(!cats){
                    window.alert("No data found");
                    ToggleLoader(false);
                    return;
                }

                for(let i = 0;i<cats.length;i++){
                    let cat = cats[i];
                    let services = cat.serviceList;
                    for(let e = 0;e<services.length;e++){
                        let service = services[e];
                        if(service.hashServiceId==serviceId){
                            serviceData = service;
                            break;
                        }
                    }

                    if(serviceData != null)
                        break;

                }

                if(serviceData){
                 
                    ToggleLoader(false);
                   let args = {
                    service:serviceData,
                    commonData:mainData,
                    siteData:context,
                    event:e,
                    allowMultiLoc:allowMulti,
                    isopen:true,
                    VgUrl:"",
                    serviceId:serviceData.encServiceId,
                    IsAddon:0
                   }

                    OpenAddOnServicePopupForAddToBook(args)

                }
                
            })


        });});

}

export function BindClassLinks(userContext:UserContext){

    let links = document.querySelectorAll('.class-link');

    links.forEach((link) => {
        
        let location = link.getAttribute('datalocation')??"";
        let classId = link.getAttribute("href")??"";
        link.setAttribute("href","#");//dont open via middle click
        let allowMulti = (link.getAttribute('dataallowmulti')??"false") == "true";
        let context = {...userContext};
        if(location){
            context.businessId = location;
        }

        link.addEventListener('click', (e) => {
            e.preventDefault();

            if((window as any).isEditor){
                return;
            }

            OpenClassFrame({ classId:classId, siteData:context,locationId:location, allowMultiLoc:allowMulti})


        });});

}

export function BindPackageLinks(userContext:UserContext){

    let links = document.querySelectorAll('.package-link');

    links.forEach((link) => {
        
        let location = link.getAttribute('datalocation')??"";
        let id = link.getAttribute("href")??"";
        link.setAttribute("href","#");//dont open via middle click

        let context = {...userContext};
        if(location){
            context.businessId = location;
        }

        link.addEventListener('click', (e) => {
            e.preventDefault();

            if((window as any).isEditor){
                return;
            }

            OpenToComponent(context,BusienssControlNames.packages,id);


        });});
}

export function BindMembershipLinks(userContext:UserContext){

    let links = document.querySelectorAll('.membership-link');

    links.forEach((link) => {
        
        let location = link.getAttribute('datalocation')??"";
        let id = link.getAttribute("href")??"";
        link.setAttribute("href","#");//dont open via middle click

        let context = {...userContext};
        if(location){
            context.businessId = location;
        }

        link.addEventListener('click', (e) => {
            e.preventDefault();

            if((window as any).isEditor){
                return;
            }

            OpenToComponent(context,BusienssControlNames.memberships,id);


        });});

}